import React, { useEffect, useState } from "react"
import { Card, Table } from "react-bootstrap"
import { db } from "../../../firebase"

export default function Players(){
    const [allPlayers, setAllplayers] = useState([])

    function getAllPlayers(){
        db.collection("appusers").get()
            .then((querySnapShot) => {
                var newAllPlayers = []
                querySnapShot.forEach((doc) => {
                    doc = doc.data()
                    var player = {
                        displayName : doc.displayName,
                        email : doc.email,
                        isAdmin : doc.private.isAdmin,
                        isDev : doc.private.isDev
                    }
                    newAllPlayers.push({player}) 
                })
                if (newAllPlayers){
                    setAllplayers(newAllPlayers.sort( compare ))
                }
            })
            .catch((e) => {
                console.log(e)
            })
    }

    function compare(a, b){
        if (a.player.displayName.charAt(0) > b.player.displayName.charAt(0)){
            return 1
        } 
        if (a.player.displayName.charAt(0) < b.player.displayName.charAt(0)){
            return -1
        }
        else {return 0}
    }

    useEffect(() => {
        getAllPlayers()
    }, [])
    
    
    const displayPlayers = allPlayers.map((elem, ind) => {
        var player = elem.player
        return (
            <tbody key={ind}>
                <tr>
                <td>{ind}</td>
                <td>{player.displayName}</td>
                </tr>
            </tbody>   
        )
    })
        
    return(
        <div>
            
            <h2>
                Admin Players
            </h2>
            <div>Implement filters</div>

            <div>
                <div>
                    <Card className="player-table-container">
                        <Card.Body>
                            <h4>All players</h4>
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                    <th>#</th>
                                    <th>Display Name</th>
                                    </tr>
                                </thead>
                                
                                {displayPlayers}
                            </Table>
                        </Card.Body>

                    </Card>
                    
                </div>
            </div>
        </div>
    )
}